import React, { Component } from "react";
import { ShowCreateForm, ShowEditForm } from "../pages/shows/show_form";
import { matchPath } from "react-router-dom";
import "./modal.scss";
import BaseModal from "./base_modal";
import get from "lodash/get";
import { getCroppedImg } from "../../lib/image-uploader";

class ShowFormModal extends Component {
  close = () => {
    this.props.history.push(this.props.closeRoute(this.props.location));
    this.props.closeModal();
  };

  getShowUUID = () => {
    var result = matchPath(this.props.location.pathname, "/shows/:showUUID/edit");
    return result && result.params && result.params.showUUID;
  };

  onSubmit = formValues => {
    var finalResult = Object.assign({}, formValues);
    if (get(finalResult, "categoryUUIDs[0].name")) {
      finalResult.categoryUUIDs = finalResult.categoryUUIDs.map(({ uuid }) => uuid);
    }

    var fileName = get(this.props.imageUplaoder, "fileName");
    if (this.isEditMode()) {
      var url = get(this.props, ["mediaFiles", this.getShow().imageMediaFileUUID, "url"]);
      fileName = url.split("/").pop();
    }

    // If we haven't set any image file data on update, then
    // we can skip the upload part.
    if (this.isEditMode() && !this.props.imageUploader.touched) {
      return this.submitHandler(finalResult, this.props.user);
    }
    if (!get(this.props.imageUploader, "image")) {
      this.props.setError("An image is required");
      return;
    }
    getCroppedImg(this.props.imageUploader).then(imageFileData => {
      this.props.fileUpload(imageFileData, fileName, this.props.user).then(result => {
        if (result.status === 200) {
          const imageUUID = get(result, "json[0].uuid");
          finalResult.imageMediaFileUUID = imageUUID;
          this.submitHandler(finalResult, this.props.user);
        }
      });
    });
  };

  submitHandler = (data, user) => {
    return this.isEditMode()
      ? this.props.updateShow(data, user)
      : this.props.createShow(data, user);
  };

  isEditMode = () => {
    return this.props.mode === "edit";
  };

  getShow = () => {
    return get(this.props, ["shows", this.getShowUUID()]);
  };

  getRenderInfo = () => {
    var show = this.getShow();
    var renderInfo = {
      title: "Create Podcast",
      initialValues: {
        alias: "",
        isComplete: false,
        isVisible: true,
        isExplicit: false,
        language: "en-US",
        ownerEmail: get(this.props, "user.email"),
        ownerName: get(
          this.props,
          "user.companyName",
          `${this.props.user.firstName} ${this.props.user.lastName}`
        ),
        copyright: "All rights reserved.",
      },
      Form: ShowCreateForm,
      show: show,
    };
    if (this.isEditMode()) {
      renderInfo.title = "Podcast Settings";
      renderInfo.initialValues = show;
      renderInfo.Form = ShowEditForm;
    }
    return renderInfo;
  };

  render() {
    var { title, initialValues, Form, show } = this.getRenderInfo();
    return (
      <BaseModal
        // Modal props
        isLoading={!(!this.isEditMode() || show)}
        showContent={Boolean(!this.isEditMode() || show)}
        title={title}
        close={this.close}
        Content={Form}
        // Passed to Form
        setImageFileData={data => {
          this.props.setImageFileData(this.props.mode, data);
        }}
        mediaFiles={this.props.mediaFiles}
        isFormLoading={this.props.isLoading}
        onSubmit={this.onSubmit}
        setError={this.props.setError}
        isSuccess={this.props.isSuccess}
        initialValues={initialValues}
        errorMessage={this.props.errorMessage}
        validationErrors={this.props.validationErrors}
        fileUpload={this.props.fileUpload}
        setImageFileUUID={uuid => {
          this.props.setImageFileUUID(this.props.mode, uuid);
        }}
        user={this.props.user}
      />
    );
  }
}

export default ShowFormModal;
